import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import BlogBlock from './BlogBlock';
import { Container, Content } from 'components/basics';
import { breakpoint } from 'utils/mediaQueries';

const ContentBlock = styled(Grid)`
  padding-top: 8rem;
  ${Content}
  ${breakpoint.down('lg')`
  padding-top: 12rem`}
  ${breakpoint.down('md')`
  padding-top:4rem`};
`;

const BlogBlocks = ({ data }) => {
  return (
    <Container>
      <ContentBlock container spacing={40} justify="center">
        <BlogBlock data={data} />
      </ContentBlock>
    </Container>
  );
};

export default BlogBlocks;
